import AntTooltip from 'antd/lib/tooltip';

export type { TooltipProps } from 'antd/es/tooltip';

export const Tooltip = AntTooltip;
